import { CreateBase, Form, useGetIdentity, useTranslate } from "ra-core";
import { useLocation } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

import { CompanyInputs } from "./CompanyInputs";

export const CompanyCreate = () => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  const location = useLocation();

  // Set when arriving from the Doors list via "Promote". This is the link
  // between the mailing universe and the sales pipeline, and it is the whole
  // point of the promote action -- without it the new company has no mail
  // history and nothing says so.
  //
  // Read from location state explicitly rather than trusting the value to
  // survive the form: address_id has no input of its own, and a field that is
  // never registered can be dropped on submit. The failure would be silent --
  // a company created successfully, simply not linked to any door.
  const promotedAddressId =
    (location.state as { record?: { address_id?: number } } | null)?.record
      ?.address_id ?? null;

  return (
    <CreateBase
      redirect="show"
      transform={(values) => {
        // add https:// before website if not present
        if (values.website && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        if (promotedAddressId != null && values.address_id == null) {
          values.address_id = promotedAddressId;
        }
        return values;
      }}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form defaultValues={{ sales_id: identity?.id }}>
            <Card>
              <CardContent>
                <CompanyInputs />
                <div
                  role="toolbar"
                  className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end gap-2"
                >
                  <CancelButton />
                  <SaveButton
                    label={translate("resources.companies.action.create", {
                      _: "Create Company",
                    })}
                  />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
